import { useState } from "react";
import axios from "axios";
import "./contactUs.css";
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [status, setStatus] = useState({ type: null, message: "" });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    if (value !== "Other") {
      setFormData({ ...formData, subject: value });
    } else {
      setFormData({ ...formData, subject: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: null, message: "" });
    setSending(true);
    const baseUrl = process.env.REACT_APP_API_URL || "";
    const apiUrl = baseUrl
      ? `${baseUrl.replace(/\/$/, "")}/api/contact`
      : "https://aok-website.onrender.com/api/contact";
    try {
      await axios.post(apiUrl, formData);
      setStatus({ type: "success", message: "Thanks! We'll be in touch soon." });
      setFormData({ name: "", email: "", subject: "", message: "" });
      setSelectedOption("");
      setTimeout(() => setStatus({ type: null, message: "" }), 5000);
    } catch (error) {
      console.error("Contact form error:", error);
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Error sending message. Please try again.";
      setStatus({ type: "error", message: msg });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Seo
        title="Contact Us"
        description="Get in touch with AOK Communications for public speaking, digital marketing, and web design."
      />
      <Header />

      <div className="contact-container reveal page-content" style={{ marginBottom: "80px" }}>
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <label htmlFor="contact-name">Your Name</label>
          <input id="contact-name" type="text" name="name" placeholder="Your Name" required onChange={handleChange} value={formData.name} />

          <label htmlFor="contact-email">Your Email</label>
          <input id="contact-email" type="email" name="email" placeholder="Your Email" required onChange={handleChange} value={formData.email} />

          <label htmlFor="contact-service">Service</label>
          <select id="contact-service" value={selectedOption} onChange={handleSelectChange} required>
            <option value="" disabled>Select a service...</option>
            <option value="Public Speaking">Public Speaking</option>
            <option value="Marketing">Marketing</option>
            <option value="Web Design">Web Design</option>
            <option value="Other">Other</option>
          </select>

          {selectedOption === "Other" && (
            <>
              <label htmlFor="contact-subject">Subject</label>
              <input id="contact-subject" type="text" name="subject" placeholder="Enter Subject" required onChange={handleChange} value={formData.subject} />
            </>
          )}

          <label htmlFor="contact-message">Your Message</label>
          <textarea id="contact-message" name="message" placeholder="Your Message" required onChange={handleChange} value={formData.message} />
          <button className="hover-lift" type="submit" disabled={sending}>
            {sending ? "Sending…" : "Send"}
          </button>
          {status.message && (
            <p className={status.type === "success" ? "contact-status success" : "contact-status error"}>
              {status.message}
            </p>
          )}
        </form>
      </div>

       <Footer />
    </>
  );
}

export default ContactUs;
